import { Plugin } from "nova_ecs/plugin";
import { DeltaPlugin } from "nova_ecs/plugins/delta_plugin";
import { MovementPlugin } from "nova_ecs/plugins/movement_plugin";
import { TimePlugin } from "nova_ecs/plugins/time_plugin";
import { AmbientPlugin } from "./ambient_plugin";
import { AnimationPlugin } from "./animation_plugin";
import { BayPlugin } from "./bay_plugin";
import { BeamPlugin } from "./beam_plugin";
import { BlastPlugin } from "./blast_plugin";
import { CollisionsPlugin } from './collisions_plugin';
import { CombatRatingPlugin } from './combat_rating_plugin';
import { ControlsPlugin } from "./controls_plugin";
import { CreateTimePlugin } from "./create_time";
import { DeathPlugin } from "./death_plugin";
import { EscortPlugin } from "./escort_plugin";
import { FireWeaponPlugin } from "./fire_weapon_plugin";
import { FleetPlugin } from "./fleet_plugin";
import { HealthPlugin } from "./health_plugin";
import { IonizedPlugin } from "./ionization_plugin";
import { InteractionPlugin } from "./interaction_plugin";
import { JumpPlugin } from "./jump_plugin";
import { MissionShipPlugin } from "./mission_ship_plugin";
import { NpcPlugin } from "./npc_plugin";
import { NpcAIPlugin } from "./npc_ai_plugin";
import { OutfitPlugin } from "./outfit_plugin";
import { PersPlugin } from "./pers_plugin";
import { PlanetPlugin } from "./planet_plugin";
import { PlatformPlugin } from "./platform_plugin";
import { ProjectilePlugin } from "./projectile_plugin";
import { ReturnToQueuePlugin } from "./return_to_queue_plugin";
import { ScanPlugin } from "./scan_plugin";
import { ShipController } from "./ship_controller_plugin";
import { ShipPlugin } from "./ship_plugin";
import { TargetPlugin } from "./target_plugin";
import { WeaponPlugin } from "./weapon_plugin";

// Users must add the multiplayer plugin and a display plugin.
// Users must also add the NovaData resource.
export const SystemPlugin: Plugin = {
    name: 'SystemPlugin',
    build(world) {
        world.addPlugin(TimePlugin);
        world.addPlugin(CreateTimePlugin);
        world.addPlugin(ReturnToQueuePlugin);
        world.addPlugin(PlatformPlugin);
        world.addPlugin(DeltaPlugin);
        world.addPlugin(ShipPlugin);
        world.addPlugin(AnimationPlugin);
        world.addPlugin(ControlsPlugin);
        world.addPlugin(ShipController);
        world.addPlugin(PlanetPlugin);
        world.addPlugin(MovementPlugin);
        world.addPlugin(DeathPlugin);
        world.addPlugin(FireWeaponPlugin);
        world.addPlugin(ProjectilePlugin);
        world.addPlugin(WeaponPlugin);
        world.addPlugin(OutfitPlugin);
        world.addPlugin(CollisionsPlugin);
        world.addPlugin(HealthPlugin);
        world.addPlugin(TargetPlugin);
        world.addPlugin(BeamPlugin);
        world.addPlugin(BayPlugin);
        world.addPlugin(JumpPlugin);
        world.addPlugin(ScanPlugin);
        world.addPlugin(NpcPlugin);
        world.addPlugin(NpcAIPlugin);
        world.addPlugin(PersPlugin);
        // The ambient population event (FUN_0041af90): jump-in burst,
        // landing/liftoff/boarding repopulation, dûde branch, despawn.
        world.addPlugin(AmbientPlugin);
        world.addPlugin(CombatRatingPlugin);
        world.addPlugin(MissionShipPlugin);
        world.addPlugin(EscortPlugin);
        world.addPlugin(InteractionPlugin);
        world.addPlugin(FleetPlugin);
        world.addPlugin(IonizedPlugin);
        world.addPlugin(BlastPlugin);
    }
};

